import { Reducer } from "redux";
import { SupplierState } from "@models/supplier";
import { SupplierActionTypes } from "@actions/supplier";

// Type-safe initialState!
export const initialState: SupplierState = {
  data: [],
  errors: undefined,
  loading: false,
  count: 0
};

const reducer: Reducer<SupplierState> = (state = initialState, action) => {
  switch (action.type) {
    case SupplierActionTypes.FETCH_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }

    case SupplierActionTypes.FETCH_SUCCESS: {
      const { data, meta } = action.payload;
      return {
        ...state,
        loading: false,
        data,
        count: meta.total_count
      };
    }

    case SupplierActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload.error };
    }

    case SupplierActionTypes.DELETE_SUCCESS: {
      return {
        ...state,
        data: state.data.filter(item => item.id != action.payload.params.id),
        count: state.count - 1
      };
    }

    case SupplierActionTypes.CREATE_SUCCESS: {
      const supplier = action.payload;
      return {
        ...state,
        data: [supplier, ...state.data],
        count: state.count + 1
      };
    }

    case SupplierActionTypes.UPDATE_SUCCESS: {
      const supplier = action.payload;
      return {
        ...state,
        data: state.data.map(item =>
          item.id == supplier.id
            ? {
                ...item,
                ...supplier
              }
            : item
        )
      };
    }

    default: {
      return state;
    }
  }
};

export { reducer as supplierReducer };
